module.exports = __webpack_public_path__ + "media/public/img/contact-b11cc6e953956a0c50a2f97983291f06.png";